<template>
  <div
    v-bind:class="statusInfo.cssClass"
    class="cep-decision-status">
    <font-awesome-icon
      v-if="statusInfo.icon"
      :icon="['fas', `${statusInfo.icon}`]"
      size="lg"
      class="cep-decision-status-icon"/>
    <strong
      class="fa-stack-1x cep-status-stacked-description"
      v-if="statusInfo.stacked">
      {{statusInfo.stackedDescription}}
    </strong>
    {{ description || statusInfo.description }}
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowFromLeft,
  faOctagon,
  faRepeat,
  faExclamationTriangle,
  faSquare,
  faMinusCircle,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faArrowFromLeft,
  faOctagon,
  faRepeat,
  faExclamationTriangle,
  faSquare,
  faMinusCircle,
);

export default {
  props: {
    status: {
      type: String,
    },
    description: {
      type: String,
    },
    variant: {
      type: String,
    },
  },
  data() {
    return {
      STATUSES: {
        NEW_BASE_YEAR: 'R',
        ERROR: 'E',
        CONTINUE_BASE_YEAR: 'C',
        GARCE_YEAR: 'G',
        NOT_PARTICIPATING: 'N',
        PARTICIPATING: 'Y',
      },
    };
  },
  computed: {
    statusInfo() {
      let icon = '';
      let description = 'Status Unknown';
      let cssClass = '';
      let stacked = false;
      let stackedDescription = '';

      switch (this.status) {
        case this.STATUSES.NEW_BASE_YEAR:
          icon = 'arrow-from-left';
          description = 'New Base Year';
          cssClass = 'cep-status-new-base-year';
          break;
        case this.STATUSES.PARTICIPATING:
          icon = 'arrow-from-left';
          description = 'New Base Year';
          cssClass = 'cep-status-new-base-year';
          break;
        case this.STATUSES.ERROR:
          icon = 'octagon';
          description = 'Error';
          cssClass = 'cep-status-error';
          break;
        case this.STATUSES.CONTINUE_BASE_YEAR:
          icon = 'repeat';
          description = 'Continue Base Year';
          cssClass = 'cep-status-continue-base-year';
          break;
        case this.STATUSES.NOT_PARTICIPATING:
          icon = 'minus-circle';
          description = 'Not Participating';
          cssClass = 'cep-status-not-participating';
          break;
        case this.STATUSES.GARCE_YEAR:
          icon = 'square';
          description = 'Grace Year';
          cssClass = 'fa-stack cep-status-grace-year';
          stacked = true;
          stackedDescription = '1';
          break;
        default:
          icon = 'exclamation-triangle';
          description = 'Not Selected';
          cssClass = 'cep-status-not-selected';
          break;
      }

      if (this.variant === 'outlined') {
        cssClass += ' cep-status-outlined';
      }

      return {
        icon,
        description,
        cssClass,
        stacked,
        stackedDescription,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  .cep-decision-status
    font-size: .85rem
    color: #212529
    line-height: 1
    .cep-decision-status-icon
      font-size: .85rem
      color: #6c757d
      margin-right: 0.3rem
      min-width: 12px
      float: left
      vertical-align: middle
    &.fa-stack
      width: auto
      height: auto
      .cep-status-stacked-description
        line-height: 1rem;
        font-family: Georgia, Times, serif;
        top: 1px;
        left: 3px;
        color: #fff
    &.cep-status-error .cep-decision-status-icon
      color: #dc3545
    &.cep-status-not-selected .cep-decision-status-icon
      color: #c46852
    &.cep-status-grace-year .cep-decision-status-icon
      color: #ffcf21
    &.cep-status-not-participating .cep-decision-status-icon
      color: #a6a6a6
    &.cep-status-outlined
      font-weight: bold
      color: #000
      padding: 0.3rem 0.43rem
      min-width: 142px
      border-radius: 4px
      border: 1px solid
      line-height: 1
      &.cep-status-new-base-year
        border-color: #385723
        background-color: #a9d18e
        .cep-decision-status-icon
          color: #385723
      &.cep-status-error
        border-color: #dc3545
      &.cep-status-not-participating
        border-color: #a6a6a6
      &.cep-status-continue-base-year
        border-color: #2f5597
        background-color: #e2f5fc
        .cep-decision-status-icon
          color: #2f5597
      &.cep-status-not-selected
        border-color: #c46852
        background-color: #ffded7
      &.cep-status-grace-year
        border-color: #ffcf21
        background-color: #fff3c6
        &.fa-stack .cep-status-stacked-description
          top: 2px;
          left: 9px;
</style>
